import { createFileRoute } from "@tanstack/react-router";
import { MultilingualServiceLanding } from "@/components/MultilingualServiceLanding";
import { SWORN_CONTENT, SWORN_HREFLANG } from "@/data/multilingual-sworn-content";
import { SEO_SITE, ctaDesc, ctaTitle } from "@/lib/seo";

const C = SWORN_CONTENT.fr;
const PATH = "/fr/sworn-translator";

export const Route = createFileRoute("/fr/sworn-translator")({
  head: () => ({
    meta: [
      { title: ctaTitle(C.h1, "/fr/sworn-translator", "th")},
      { name: "description", content: ctaDesc(C.intro.slice(0, 160), "/fr/sworn-translator", "th")},
      { property: "og:title", content: ctaTitle(C.h1, "/fr/sworn-translator", "th")},
      { property: "og:description", content: ctaDesc(C.intro.slice(0, 160), "/fr/sworn-translator", "th")},
      { property: "og:url", content: SEO_SITE + PATH },
      { property: "og:locale", content: "fr_FR" },
    ],
    links: [
      { rel: "canonical", href: SEO_SITE + PATH },
      ...Object.entries(SWORN_HREFLANG).map(([k, v]) => ({
        rel: "alternate", hreflang: k === "th" ? "th-TH" : k === "en" ? "en" : k,
        href: SEO_SITE + v,
      })),
      { rel: "alternate", hreflang: "x-default", href: SEO_SITE + "/sworn-translator" },
    ],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "Service",
        name: C.h1, url: SEO_SITE + PATH, areaServed: "TH",
        inLanguage: "fr", serviceType: "Sworn Translation",
        provider: { "@type": "ProfessionalService", name: "NYC Language Institute", url: SEO_SITE },
      }) },
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "FAQPage", inLanguage: "fr",
        mainEntity: C.faqs.map((f) => ({
          "@type": "Question", name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      }) },
    ],
  }),
  component: () => <MultilingualServiceLanding c={C} />,
});
